import { Currency } from '@sequencehq/api/utils'
import { add, isAfter } from '@sequencehq/utils/dates'
import {
  GENERATE_ANALYSIS_REPORT_COPY,
  MAX_RANGE_MONTHS,
  XERO_LEDGER_ACCOUNT_CODE_PATTERN
} from './generateAnalysisReport.constants'

export type AnalysisReportFormValues = {
  currency: Currency | undefined
  xeroLedgerAccountCode: string | undefined
  dateRange: [Date, Date] | undefined
}

export type AnalysisReportFormErrors = {
  currency?: string
  xeroLedgerAccountCode?: string
  dateRange?: string
}

const { validation } = GENERATE_ANALYSIS_REPORT_COPY

export const validateAnalysisReportForm = (
  values: AnalysisReportFormValues
): AnalysisReportFormErrors => {
  const currency = values.currency ? undefined : validation.currencyRequired

  const xeroLedgerAccountCode = getLedgerAccountError(
    values.xeroLedgerAccountCode
  )

  const dateRange = getDateRangeError(values.dateRange)

  return {
    ...(currency ? { currency } : {}),
    ...(xeroLedgerAccountCode ? { xeroLedgerAccountCode } : {}),
    ...(dateRange ? { dateRange } : {})
  }
}

export const isAnalysisReportFormValid = (
  errors: AnalysisReportFormErrors
): boolean => Object.keys(errors).length === 0

const getLedgerAccountError = (
  xeroLedgerAccountCode: string | undefined
): string | undefined => {
  if (!xeroLedgerAccountCode) {
    return validation.ledgerAccountRequired
  }

  return XERO_LEDGER_ACCOUNT_CODE_PATTERN.test(xeroLedgerAccountCode)
    ? undefined
    : validation.ledgerAccountInvalid
}

const getDateRangeError = (
  dateRange: [Date, Date] | undefined
): string | undefined => {
  if (!dateRange) {
    return validation.dateRangeRequired
  }

  const [from, to] = dateRange

  if (isAfter(from, to)) {
    return validation.fromAfterTo
  }

  const latestAllowedTo = add(from, { months: MAX_RANGE_MONTHS })

  return isAfter(to, latestAllowedTo) ? validation.rangeTooLong : undefined
}
